import { render, staticRenderFns } from "./rentabilidade.vue?vue&type=template&id=67d4f49b&scoped=true&"
import script from "./rentabilidade.vue?vue&type=script&lang=js&"
export * from "./rentabilidade.vue?vue&type=script&lang=js&"
import style0 from "./rentabilidade.vue?vue&type=style&index=0&id=67d4f49b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d4f49b",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67d4f49b')) {
      api.createRecord('67d4f49b', component.options)
    } else {
      api.reload('67d4f49b', component.options)
    }
    module.hot.accept("./rentabilidade.vue?vue&type=template&id=67d4f49b&scoped=true&", function () {
      api.rerender('67d4f49b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Rentabilidade/components/rentabilidade.vue"
export default component.exports